import React, { Component } from 'react';
import { Table, Button, Alert, Spinner  } from 'reactstrap';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import { Card, CardHeader, CardBody, Row, Col, Collapse, Input } from 'reactstrap';
import { InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';
import { AiOutlineSearch, AiOutlineReload } from 'react-icons/ai';
import { FaEdit, FaPlus, FaTrashAlt } from 'react-icons/fa';
import { withRouter } from 'react-router-dom';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
/*import history from "../history";*/
import './NavMenu.css';
import url from "./variables/url.js";
import { AppContext } from '../AppContext';
import Paginacion from './Paginacion';
import ActividadCard from './ActividadCard';
import ReactHTMLTableToExcel from "react-html-table-to-excel";

/*const localBack = url.localBack;*/
const localBack = process.env.REACT_APP_BACK;
const homepage = process.env.REACT_APP_EXP;


export class GestionActividadPagination extends Component {
    static displayName = GestionActividadPagination.name;

    constructor(props) {
        super(props);
        this.state = {
            status: 0,
            page: 1,
            buscar: '',
            buscarNombre: '',
            buscarCategoria: 1,
            buscarTipo: 1,
            buscarEstado: 'I',
            loading: true,            
            activeTab: 1,
            collapse: 1,
            idestudiante: 0,
            actividades: [],
            categorias: [],
            tipos: [],
            iduser: 0,
            roles: [],
            currentActividades: [], currentPage: null, totalPages: null,
            /*pestanias: [{id: 1, nombre: 'Estudiante' },{ id: 2, nombre: 'Categoria' },{ id: 3, nombre: 'Tipo Actividad' }],*/
            pestanias: [{ id: 1, nombre: 'Estado' },{id: 2, nombre: 'Matricula' },{id: 3, nombre: 'Apellidos/Nombres' },{ id: 4, nombre: 'Categoria' },{ id: 5, nombre: 'Tipo Actividad' }],
            estados: [{ id: 'I', nombre: 'En Revisi\u00F3n' }, { id: 'R', nombre: 'Rechazadas' }, { id: 'A', nombre: 'Aprobadas' }, { id: 'D', nombre: 'Devueltas' }],
            totalPageA: 0,
            actualPage: 1,
            limite: 10,
            siblingCount: 1,
            currentPage: 1,
            currentTotalPages: 0,
            postsActividad: [],
            respItems: -1,
            postsPerPage: 10
        };

        this.handleEdit = this.handleEdit.bind(this);
        this.toggle = this.toggle.bind(this);
        this.toggleCard = this.toggleCard.bind(this);        
        this.searchById = this.searchById.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleSearchNombre = this.handleSearchNombre.bind(this);
        this.onChangeCategoria = this.onChangeCategoria.bind(this);
        this.onChangeTipo = this.onChangeTipo.bind(this);
        this.onChangeEstado = this.onChangeEstado.bind(this);
        this.actualizarActividades = this.actualizarActividades.bind(this);
        this.onChangeLimite = this.onChangeLimite.bind(this);
        if (this.props.location.state)
         this.actualizarActividades(this.props.location.state.actividad)
    }

    componentDidMount() {
        this.populateInfoData();
        this.populateActividades();        
        let currentUser = this.context;
        if (currentUser != null && this.state.iduser == 0) {
            this.setState({ iduser: currentUser.idpersona, roles: currentUser.roles });
            if (currentUser.roles.includes('ADMINISTRADOR')) {
                //console.log('Ok');
            } else {
                this.isForbidden();
            }

        }
    }

    componentDidUpdate() {
        let currentUser = this.context;
        if (currentUser != null && this.state.iduser == 0) {
            this.setState({ iduser: currentUser.idpersona, roles: currentUser.roles });
            if (currentUser.roles.includes('ADMINISTRADOR')) {
                //console.log('Ok');
            } else {
                this.isForbidden();
            }

        }
    }

    isForbidden() {
        this.props.history.push({
            pathname: homepage,
        })
    }

    setPagePrevious() {
        if (this.state.currentPage !== 1) {
            let p = this.state.currentPage;
            this.setState({
                currentPage: p - 1
            });
        }
    }

    setPageNext() {
        if (this.state.currentPage !== this.state.totalPageA) {
            let p = this.state.currentPage;
            this.setState({
                currentPage: p + 1
            });
        }
    }

    setPage = (pageNum) => {
        this.setState({ currentPage: pageNum })
    }   

    setYouAreMySibling(num) {
        let actualPage = this.state.currentPage;
        let sibling = this.state.siblingCount;
        let total = this.state.totalPageA;
        let valor = false;
        if (num === actualPage || num - sibling === actualPage || num + sibling === actualPage) {
            valor = true;
        }
        if (actualPage === 1 && (num - 1 === actualPage || num - 2 === actualPage || num - 3 === actualPage)) {
            valor = true;
        }
        if (actualPage === 2 && (num - 1 === actualPage || num - 2 === actualPage)) {
            valor = true;
        }
        if (actualPage === total && (num + 1 === actualPage || num + 2 === actualPage || num + 3 === actualPage)) {
            valor = true;
        }
        if (actualPage === total - 1 && (num + 1 === actualPage || num + 2 === actualPage)) {
            valor = true;
        }        
        return valor;
    }

    reLoadTotalPage(lenActividades, limite) {
        this.setState({ totalPageA: Math.ceil(lenActividades / limite), actualPage: 1, currentPage: 1 });
                
    }

    actualizarActividades(actividad) {
        let actividades = this.state.actividades;
        let indice = actividades.indexOf(actividad);
        actividades[indice] = actividad;
        this.setState({ actividades: actividades });
    }

    onChangeLimite(event) {
        //console.log('Cambio limite');
        //console.log(event.target.value);
        var num = event.target.value;
        this.setState({ limite: num });
        this.reLoadTotalPage(this.state.actividades.length, num);
    }

    miEstado(est) {
        let estado = 'En Revisi\u00F3n';
        if (est == 'A') {
            estado = 'Aprobado';
        } else if (est == 'R') {
            estado = 'Rechazado';
        } else if (est == 'D') {
            estado = 'Devuelto';
        }
        return estado;
    }

    componentWillReceiveProps(nextProps) {
        /*console.log('componentWillReceiveProps', nextProps);*/
        this.setState(nextProps);
    }

    onPageChanged = data => {
        const { actividades } = this.state;
        const { currentPage, totalPages, pageLimit } = data;
        const offset = (currentPage - 1) * pageLimit;
        const currentActividades = actividades.slice(offset, offset + pageLimit);

        this.setState({ currentPage, currentActividades, totalPages });
    }

    KeyPressEstudiante = (event) => {
        if (event.charCode === 13 && this.state.buscar !== "") {    
            this.searchById();
        }
    }

    KeyPressEstudianteNombre = (event) => {
        if (event.charCode === 13 && this.state.buscarNombre !== "") {
            this.searchByNombre();
        }
    }

    KeyPressCategoria = (event) => {
        if (event.charCode === 13 && this.state.buscarCategoria >= 1) {
            this.searchByCategoria();
        }
    }

    KeyPressTipo = (event) => {
        if (event.charCode === 13 && this.state.buscarCategoria >= 1) {
            this.searchByTipo();
        }
    }

    renderGestionTable(actividades) {
        
        const indexOfLastPost = this.state.currentPage * this.state.limite;

        const indexOfFirstPost = indexOfLastPost - this.state.limite;

        const currentPosts = actividades.slice(indexOfFirstPost, indexOfLastPost);

        const pageNumbers = []

        for (let i = 1; i <= Math.ceil(actividades.length / this.state.limite); i++) {
            pageNumbers.push(i);
        }

        return (
            <div>                
                {this.state.respItems > 0 ?
                    <>
                        <div>
                            <ReactHTMLTableToExcel
                                id="table-xls-button"
                                className="page-link"
                                table="table-to-xls"
                                filename="Data"
                                sheet="sheet1"
                                buttonText="Exportar como Excel"
                            />
                        </div>

                        <br/>

                        <div className="w-full flex justify-around">
                            <Row hidden={this.state.actividades.length === 0} id={'newPagination'}>
                                <Col xs="2">
                                    <Input className="col-md-6" style={{ width: '5vw' }} type="select" onChange={this.onChangeLimite} value={this.state.limite} >
                                        <option hidden key={"sel-1"} selected={1 == this.state.limite} value={1}>{1}</option>
                                        <option key={"sel-5"} selected={5 == this.state.limite} value={5}>{5}</option>
                                        <option key={"sel-10"} selected={10 == this.state.limite} value={10}>{10}</option>
                                        <option key={"sel-25"} selected={25 == this.state.limite} value={25}>{25}</option>
                                        <option key={"sel-50"} selected={50 == this.state.limite} value={50}>{50}</option>
                                        <option key={"sel-100"} selected={100 == this.state.limite} value={100}>{100}</option>
                                    </Input>
                                </Col>
                                <Col>
                            <Pagination hidden={pageNumbers.length < 1} >
                                <PaginationItem active={this.state.currentPage === 1} onClick={() => { this.setPage(1); }}>
                                    <PaginationLink>
                                        {1}
                                    </PaginationLink>
                                </PaginationItem>
                                <PaginationItem hidden={this.state.totalPageA < 5 || this.state.currentPage === 1} onClick={() => { this.setPagePrevious(); }}>
                                    <PaginationLink previous />
                                </PaginationItem>
                                {pageNumbers.map((page, i) =>
                                (
                                    <PaginationItem hidden={i + 1 === 1 || i + 1 === this.state.totalPageA || !this.setYouAreMySibling(i + 1)} active={this.state.currentPage === i + 1} onClick={() => { this.setPage(i + 1); }}>
                                        <PaginationLink>
                                            {i + 1}
                                        </PaginationLink>
                                    </PaginationItem>)
                                )}
                                <PaginationItem hidden={this.state.totalPageA < 5 || this.state.currentPage === this.state.totalPageA} onClick={() => { this.setPageNext(); }}>
                                    <PaginationLink next />
                                </PaginationItem>
                                <PaginationItem hidden={this.state.totalPageA === 1} active={this.state.currentPage === this.state.totalPageA} onClick={() => { this.setPage(this.state.totalPageA); }}>
                                    <PaginationLink>
                                        {this.state.totalPageA}
                                    </PaginationLink>
                                </PaginationItem>
                                    </Pagination>
                                </Col>
                            </Row>
                        </div>
                        
                        <div>
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Actividad</th>
                                        <th>Estudiante</th>
                                        <th>Competencia</th>
                                        <th>Tipo Actividad</th>
                                        <th>Estado</th>
                                        <th>Acciones</th>
                                        <th>Responsable</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {currentPosts.map((act, i) => {
                                        return <tr id={i} key={i} hidden={!(this.state.actualPage === Math.ceil((i + 1) / this.state.limite))}>
                                            <td>{(i + 1 + (this.state.limite * (this.state.currentPage - 1)))}</td>
                                            <td>{act.nombre}</td>
                                            {act.estudiante !== null ? <td>{act.estudiante.apellidos + ' ' + act.estudiante.nombres}</td> : <td>-----</td>}
                                            <td>{this.state.categorias.filter(cate => cate.idaexinsignia === act.categoria).map(actcat => actcat.nombre)}</td>
                                            <td>{this.state.tipos.filter(tipo => tipo.idaextipoactividad === act.idaextipoactividad).map(acttipo => acttipo.nombre)}</td>
                                            <td> {act.registroActividadGestion != null ? this.miEstado(act.registroActividadGestion.estado) : <>X</>} </td>
                                            <th><FaEdit className="icon-pointer" onClick={(id) => this.handleEdit(act.idaexregistroactividad)} /></th>
                                            <td>{act.registroActividadGestion != null ? <>{act.registroActividadGestion.responsable.apellidos}  {act.registroActividadGestion.responsable.nombres} </> : <>No registrado</>} </td>
                                        </tr>
                                    }
                                    )}
                                </tbody>

                            </Table>
                        </div>

                        <div className="hidden-element">
                            <Table id="table-to-xls">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Actividad</th>
                                        <th>Estudiante</th>
                                        <th>IdPersona</th>
                                        <th>Matricula</th>
                                        <th>Identificacion</th>
                                        <th>Competencia</th>
                                        <th>Tipo Actividad</th>
                                        <th>A&ntilde;o</th>
                                        <th>Fecha</th>
                                        <th>Estado</th>
                                        <th>Responsable</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {actividades.map((act, i) => {
                                        return <tr id={i} key={i}>
                                            <td>{(i + 1 + (this.state.limite * (this.state.currentPage - 1)))}</td>
                                            <td>{act.nombre}</td>
                                            {act.estudiante !== null ? <td>{act.estudiante.apellidos + ' ' + act.estudiante.nombres}</td> : <td>-----</td>}
                                            {act.estudiante !== null ? <td>{act.estudiante.idpersona}</td> : <td>-----</td>}
                                            {act.estudiante !== null ? <td>{act.estudiante.codestudiante}</td> : <td>-----</td>}
                                            {act.estudiante !== null ? <td>{act.estudiante.numeroidentificacion}</td> : <td>-----</td>}
                                            <td>{this.state.categorias.filter(cate => cate.idaexinsignia === act.categoria).map(actcat => actcat.nombre)}</td>
                                            <td>{this.state.tipos.filter(tipo => tipo.idaextipoactividad === act.idaextipoactividad).map(acttipo => acttipo.nombre)}</td>
                                            <td> {act.anio} </td>
                                            <td> {act.ultimoCambio} </td>
                                            <td> {act.registroActividadGestion != null ? this.miEstado(act.registroActividadGestion.estado) : <>X</>} </td>
                                            <td>{act.registroActividadGestion != null ? <>{act.registroActividadGestion.responsable.apellidos}  {act.registroActividadGestion.responsable.nombres} </> : <>No registrado</>} </td>
                                        </tr>
                                    }
                                    )}
                                </tbody>

                            </Table>
                        </div>

                    </>
                    : <><div /></>}
                {this.state.respItems === 0 ? < Card body className="text-center py-3">No se encontraron Resultados.</Card> : <></>}
            </div>
        );
    }

    render() {
        let contents = this.state.loading
            ? <><Spinner animation="grow" /></>
            : this.renderGestionTable(this.state.actividades);

        return (
            <div>
                <Nav pills>
                    {this.state.pestanias.map(pes =>
                        <NavItem>
                            <NavLink className="icon-pointer" active={pes.id === this.state.activeTab} onClick={() => { this.toggle(pes.id); }}>
                                {pes.nombre}
                            </NavLink>
                        </NavItem>
                    )}
                </Nav>
                <hr />
                <TabContent activeTab={this.state.activeTab}>
                    <TabPane tabId={1}>
                        <Row>
                            <InputGroup className="col-md-6">
                                <Button color="primary" onClick={() => this.populateActividades()}><AiOutlineReload /></Button>
                                <Input className="form-control" type="select" onChange={this.onChangeEstado} >
                                    {this.state.estados.map(estado =>
                                        <option key={estado.id} value={estado.id}>{estado.nombre}</option>
                                    )
                                    }
                                </Input>
                                <InputGroupAddon addonType="append">
                                    <InputGroupText onClick={() => this.searchByEstado()}>
                                        <AiOutlineSearch />
                                    </InputGroupText>
                                </InputGroupAddon>
                            </InputGroup>
                        </Row>
                        <hr />
                    </TabPane>
                    <TabPane tabId={2}>
                        <Row>
                            <InputGroup className="col-md-6">
                                <Button color="primary" onClick={() => this.populateActividades()}><AiOutlineReload /></Button>
                                <Input placeholder="20210..." onChange={this.handleSearch} onKeyPress={this.KeyPressEstudiante} value={this.state.buscar} />
                                <InputGroupAddon addonType="append">
                                    <InputGroupText onClick={() => this.searchById()}>
                                        <AiOutlineSearch />
                                    </InputGroupText>
                                </InputGroupAddon>
                            </InputGroup>
                        </Row>
                        <hr />
                    </TabPane>
                    <TabPane tabId={3}>
                        <Row>
                            <InputGroup className="col-md-6">
                                <Button color="primary" onClick={() => this.populateActividades()}><AiOutlineReload /></Button>
                                <Input placeholder="APELLIDOS NOMBRE..." onChange={this.handleSearchNombre} onKeyPress={this.KeyPressEstudianteNombre} value={this.state.buscarNombre} />
                                <InputGroupAddon addonType="append">
                                    <InputGroupText onClick={() => this.searchByNombre()}>
                                        <AiOutlineSearch />
                                    </InputGroupText>
                                </InputGroupAddon>
                            </InputGroup>
                        </Row>
                        <hr />
                    </TabPane>
                    <TabPane tabId={4}>
                        <Row>
                            <InputGroup className="col-md-6">
                                <Button color="primary" onClick={() => this.populateActividades()}><AiOutlineReload /></Button>
                                <Input className="form-control" type="select" onChange={this.onChangeCategoria} onKeyPress={this.KeyPressCategoria} >
                                    {this.state.categorias.map(insignia =>
                                        <option key={insignia.idaexinsignia} value={insignia.idaexinsignia}>{insignia.nombre}</option>
                                    )
                                    }
                                </Input>
                                <InputGroupAddon addonType="append">
                                    <InputGroupText onClick={() => this.searchByCategoria()}>
                                        <AiOutlineSearch />
                                    </InputGroupText>
                                </InputGroupAddon>
                            </InputGroup>
                        </Row>
                        <hr />
                    </TabPane>
                    <TabPane tabId={5}>
                        <Row>
                            <InputGroup className="col-md-6">
                                <Button color="primary" onClick={() => this.populateActividades()}><AiOutlineReload /></Button>
                                <Input className="form-control" type="select" onChange={this.onChangeTipo} onKeyPress={this.KeyPressTipo} >
                                    {this.state.tipos.map(tipo =>
                                        <option key={tipo.idaextipoactividad} value={tipo.idaextipoactividad}>{tipo.nombre}</option>
                                    )
                                    }
                                </Input>
                                <InputGroupAddon addonType="append">
                                    <InputGroupText onClick={() => this.searchByTipo()}>
                                        <AiOutlineSearch />
                                    </InputGroupText>
                                </InputGroupAddon>
                            </InputGroup>
                        </Row>
                        <hr />
                    </TabPane>
                </TabContent>
                {contents}
            </div>
        );
    }

    populateActividades() {

        //fetch(localBack + '/api/RegistroActividad/GetWithGestion', {
        fetch(localBack + '/api/RegistroActividad/GetByEstado/I', {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => {
                this.setState({ status: response.status, actividades: []});
                return response.json();
            })
            .then(data => {                
                if (data.strEstado == 'S') {             
                    this.setState({ actividades: data.objDatos, loading: false, respItems: data.objDatos.length });
                    this.reLoadTotalPage(this.state.actividades.length, this.state.limite);
                } else {
                    this.setState({ actividades: [], loading: false, respItems: 0 });
                    this.reLoadTotalPage(this.state.actividades.length, this.state.limite);
                }
            });
        /*this.setState({ actividades: insig.objDatos, loading: false });*/
    }

    populateGestion() {

        fetch(localBack + '/api/RegistroActividad/GetWithGestion', {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => {
                this.setState({ status: response.status });
                return response.json();
            })
            .then(data => {
                //console.log(data.strMensaje);
                if (data.strEstado == 'S') {
                    this.setState({ actividades: data.objDatos });
                } else {
                    this.setState({ actividades: [] });
                }
            });
        /*this.setState({ actividades: insig.objDatos, loading: false });*/
    }

    populateInfoData() {
        fetch(localBack + '/api/Insignia', {
                method: 'GET',
                /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
            })
                .then(response => response.json())
                .then(data => {                    
                    this.setState({
                        categorias: data.objDatos
                    });
                });

        fetch(localBack + '/api/TipoActividad', {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => response.json())
            .then(data => {                
                this.setState({
                    tipos: data.objDatos                    
                });
            });        
        
    }

    newAct() {
        //console.log('Nueva Actividad');
        this.props.history.push(homepage+'Add-Act');
    }

    handleEdit(id) {        
        this.props.history.replace(homepage+"Gestion/" + id);
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {            
            this.setState({
                activeTab: tab
            });
        }
    }

    toggleCard(e) {
        let event = e.target.dataset.event;
        this.setState({ collapse: this.state.collapse === Number(event) ? 0 : Number(event) });        
    }    

    handleSearch = async function(event) {
        await this.setState({ buscar: event.target.value });        
    }

    handleSearchNombre = async function (event) {
        //console.log(event.target.value);
        await this.setState({ buscarNombre: event.target.value });
    }

    onChangeCategoria = async function (event) {
        //console.log('Cambio Categoria');
        //console.log(event.target.value);
        var id = event.target.value;
        await this.setState({ buscarCategoria: id });                
    }


    onChangeTipo = async function(e) {
        //console.log('Cambio Tipo');
        //console.log(e.target.value);
        var id = e.target.value;
        await this.setState({ buscarTipo: id });                
    }

    onChangeEstado = async function (e) {
        //console.log('Cambio Tipo');
        //console.log(e.target.value);
        var siglaEstado = e.target.value;
        //console.log(id);
        await this.setState({ buscarEstado: siglaEstado });
    }

    searchById() {
        this.setState({ loading: true });

        if (this.state.buscar !== '') {
            fetch(localBack + '/api/RegistroActividad/GetByCodestudiante/' + this.state.buscar, {
                method: 'GET',
                /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
            })
                .then(response => {
                    this.setState({ status: response.status, loading: false, actividades: [] });
                    return response.json();
                })
                .then(data => {
                    //console.log(data.strEstado);
                    if (data.strEstado == 'S') {
                        this.setState({ actividades: data.objDatos, loading: false, respItems: data.objDatos.length });
                        this.reLoadTotalPage(this.state.actividades.length, this.state.limite);
                    } else {
                        this.setState({ actividades: [], loading: false, respItems: 0 });
                        this.reLoadTotalPage(this.state.actividades.length, this.state.limite);
                    }
                });           
        } else {
            this.setState({ loading: false });
            //console.log('No se ha escrito un matricula');
        }        
    }

    searchByNombre() {
        this.setState({ loading: true });

        if (this.state.buscarNombre !== '') {
            fetch(localBack + '/api/RegistroActividad/GetByNombreEstudiante/' + this.state.buscarNombre, {
                method: 'GET',
                /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
            })
                .then(response => {
                    this.setState({ status: response.status, loading: false, actividades: [] });
                    return response.json();
                })
                .then(data => {
                    //console.log(data.strEstado);
                    if (data.strEstado == 'S') {
                        this.setState({ actividades: data.objDatos, loading: false, respItems: data.objDatos.length });
                        this.reLoadTotalPage(this.state.actividades.length, this.state.limite);
                    } else {
                        this.setState({ actividades: [], loading: false, respItems: 0 });
                        this.reLoadTotalPage(this.state.actividades.length, this.state.limite);
                    }
                });
        } else {
            this.setState({ loading: false });
            //console.log('No se ha escrito nombre estudiante');
        }
    }

    searchByCategoria() {
        this.setState({ loading: true });

        fetch(localBack + '/api/RegistroActividad/GetByCategoria/' + this.state.buscarCategoria, {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => {
                this.setState({ status: response.status, actividades: [] });
                return response.json();
            })
            .then(data => {
                //console.log(data.strMensaje);
                if (data.strEstado == 'S') {
                    this.setState({ actividades: data.objDatos, loading: false, respItems: data.objDatos.length});
                    this.reLoadTotalPage(this.state.actividades.length, this.state.limite);
                } else {
                    this.setState({ actividades: [], loading: false, respItems: 0 });
                    this.reLoadTotalPage(this.state.actividades.length, this.state.limite);
                }
            });     
    }

    searchByTipo() {
        this.setState({ loading: true });

        fetch(localBack + '/api/RegistroActividad/GetByTipoActividad/' + this.state.buscarTipo, {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => {
                this.setState({ status: response.status, actividades: [] });
                return response.json();
            })
            .then(data => {
                //console.log(data.strMensaje);
                if (data.strEstado == 'S') {
                    this.setState({ actividades: data.objDatos, loading: false, respItems: data.objDatos.length});
                    this.reLoadTotalPage(this.state.actividades.length, this.state.limite);
                } else {
                    this.setState({ actividades: [], loading: false, respItems: 0 });
                    this.reLoadTotalPage(this.state.actividades.length, this.state.limite);
                }
            });        
    }

    searchByEstado() {
        this.setState({ loading: true });
        //console.log(this.state.buscarEstado);

        fetch(localBack + '/api/RegistroActividad/GetByEstado/' + this.state.buscarEstado, {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => {
                this.setState({ status: response.status, actividades: [] });
                return response.json();
            })
            .then(data => {
                //console.log(data.strMensaje);
                if (data.strEstado == 'S') {
                    this.setState({ actividades: data.objDatos, loading: false, respItems: data.objDatos.length });
                    this.reLoadTotalPage(this.state.actividades.length, this.state.limite);
                } else {
                    this.setState({ actividades: [], loading: false, respItems: 0 });
                    this.reLoadTotalPage(this.state.actividades.length, this.state.limite);
                }
            });
    }

    onlyNumber = (event) => {
        if (!/[0-9]/.test(event.key)) {
            event.preventDefault();
        }
    };

}
GestionActividadPagination.contextType = AppContext;
export default withRouter(GestionActividadPagination);